const authConfig = {
    'region': 'us-east-2',
    'userPoolId': 'us-east-2_lAg65HPrI',
    'userPoolWebClientId': '5e1tfc9h6b99fl7ruccshcrun2',
    'recurlyData': {
        key: 'ewr1-U2HjyhfLzv4xkZ4RpAUIVZ',
        url: 'https://js.recurly.com/v4/recurly.js'}
    };
export default authConfig;